import { InjectionToken } from '@angular/core';

export const PROJECTINFO_ENDPOINT = new InjectionToken<string>('zerops-project-info-endpoint');
